
import React from 'react';
import { Label } from "@/components/ui/label";
import { Input } from "@/components/ui/input";
import { FormDescription } from "@/components/ui/form";
import { UseFormReturn } from "react-hook-form";
import { CampaignSettings } from "../types";

interface RewardConfigSectionProps {
  form: UseFormReturn<CampaignSettings>;
}

export const RewardConfigSection: React.FC<RewardConfigSectionProps> = ({
  form
}) => {
  const { watch, setValue } = form;
  const subType = watch('subType');

  return (
    <div className="space-y-4">
      <h3 className="text-lg font-medium">Reward Configuration</h3>
      <div className="grid grid-cols-2 gap-4">
        <div className="space-y-2">
          <Label htmlFor="referrerReward">Referrer Reward</Label>
          <Input 
            id="referrerReward"
            type="number" 
            value={watch('referrerReward')} 
            onChange={e => setValue('referrerReward', Number(e.target.value))}
          />
          <p className="text-sm text-muted-foreground">
            Value rewarded to the referrer
          </p>
        </div>

        <div className="space-y-2">
          <Label htmlFor="refereeReward">Referee Reward</Label>
          <Input 
            id="refereeReward"
            type="number" 
            value={watch('refereeReward')} 
            onChange={e => setValue('refereeReward', Number(e.target.value))}
            disabled={subType === 'single'}
          />
          <p className="text-sm text-muted-foreground">
            Value rewarded to the referred user
          </p>
        </div>
      </div>
    </div>
  );
};
